module.exports = __webpack_public_path__ + "img/feature-icon2.1854a0cf.png";